import React from "react";
import TripCard from "./TripCard";
import "../css/TripsList.css";
import { useNavigate } from "react-router-dom";

const TripsList = ({ title, trips, footerName, isClickable }) => {
  const navigate = useNavigate();

  const handleCardClick = (trip) => {
    if (!isClickable) return;
    if (trip.externalLink) {
      window.location.href = trip.externalLink;
    } else {
      navigate(`/${trip.guid}`);
    }

  };

  return (
    <div className="trips-list">
      <h1 className="trips-list-title">{title}</h1>
      <div className="trips-list-grid">
        {trips.map((trip) => (
          <div
            key={trip.guid}
            onClick={() => handleCardClick(trip)}
            className={`trip-card-wrapper ${
              isClickable ? "clickable" : "disabled"
            }`}
          >
            <TripCard
              title={trip.name}
              startDate={trip.startDate}
              endDate={trip.endDate}
              description={trip.description}
              photo={trip.photoThumbnailLink}
              photoSource={trip.photoSource}
              footerName={footerName}
              isClickable={isClickable}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default TripsList;
